import { Category } from '@/domain/models/content/category'
import { ClassType } from '@/domain/models/content/class-type'
import { ContentFormat } from '@/domain/models/content/content-format'
import { ContentLanguageFormatType } from '@/domain/models/content/content-language-format-type'
import { mapRecommendedChipsFields } from '@/domain/models/content/recommended-chips-types'
import { ProductType } from '@/domain/models/content/product-type'
import { Shift } from '@/domain/models/content/shift'
import { Subtype } from '@/domain/models/content/subtype'
import { CountryCode } from '@/domain/models/country-code'
import { InstitutionContractType } from '@/domain/models/institution/institution-contract-type'
import { createLocalTimezoneDateFromString } from '@/main/helpers'
import {
  FormattedUserContentDetails,
  UserContentDetailsResponse
} from './user-content-details-service-types'

export const formatUserContentDetails = (
  data: UserContentDetailsResponse
): FormattedUserContentDetails => {
  const { languageFormats } = data

  return {
    ...data,
    productType: ProductType.getByName(data.productType),
    category: Category.getByName(data.category),
    subtype: Subtype.getById(data.subtypeId),
    format: ContentFormat.getByName(data.format),
    startAt: createLocalTimezoneDateFromString(data.startAt),
    classType: data.classType ? ClassType.getByName(data.classType) : null,
    languageFormats: languageFormats.map(format => ({
      ...format,
      type: ContentLanguageFormatType.getByName(format.type)
    })),
    institution: {
      ...data.institution,
      contractType: InstitutionContractType.getByName(data.institution.contractType)
    },
    shift: data.shift ? Shift.getByName(data.shift) : null,
    unit: {
      name: data.unit?.name ?? '',
      address: {
        country: data.unit?.address?.country
          ? CountryCode.getByValue(data.unit.address.country)
          : null,
        state: data.unit?.address?.state ?? '',
        city: data.unit?.address?.city ?? '',
        neighborhood: data.unit?.address?.neighborhood ?? '',
        location: data.unit?.address?.location ?? '',
        complement: data.unit?.address?.complement ?? '',
        zipCode: data.unit?.address?.zipCode ?? ''
      }
    },
    ...mapRecommendedChipsFields({ ...data, skillRecommends: data?.institution?.skillRecommends })
  }
}
